var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.88269L11.5 9L23 2.88269C22.9574 2.10302 22.6363 1.37018 22.1024 0.834247C21.5685 0.298315 20.8622 -0.000143193 20.1282 5.15387e-08H2.87176C2.13777 -0.000143193 1.43149 0.298315 0.897592 0.834247C0.363692 1.37018 0.0425718 2.10302 0 2.88269V2.88269Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6L11.5 11.5823L0 6V14.2088C0 14.9491 0.302901 15.659 0.842068 16.1825C1.38123 16.7059 2.1125 17 2.875 17H20.125C20.8875 17 21.6188 16.7059 22.1579 16.1825C22.6971 15.659 23 14.9491 23 14.2088V6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconWhite);
export default __webpack_public_path__ + "static/media/email-icon-white.1cba44db4138bdcae9ddccc9ee764605.svg";
export { ForwardRef as ReactComponent };